@if (loading()) {
	<nz-spin nzSimple nzSize="small"></nz-spin>
} @else {
	@if (section(); as section) {
		<div class="horizontal">
			<nz-tag [nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR" [nz-tooltip]="'Existing teachers in the section.'">
				<nz-icon nzType="user"></nz-icon>
				{{ existingTeachers() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR"
				[nz-tooltip]="'How many new teachers will be assigned to this section.'"
			>
				<nz-icon nzType="user"></nz-icon>
				{{ addedTeachers() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_REMOVED_COLOR"
				[nz-tooltip]="'How many teachers will be unassigned from this section.'"
			>
				<nz-icon nzType="user"></nz-icon>
				{{ removedTeachers() }}
			</nz-tag>
		</div>

		<div class="horizontal">
			<nz-tag [nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR" [nz-tooltip]="'Existing students in the section.'">
				<nz-icon nzType="team"></nz-icon>
				{{ existingStudents() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR"
				[nz-tooltip]="'How many new students will be enrolled in this section.'"
			>
				<nz-icon nzType="team"></nz-icon>
				{{ addedStudents() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_REMOVED_COLOR"
				[nz-tooltip]="'How many existing students will be unenrolled from this section.'"
			>
				<nz-icon nzType="team"></nz-icon>
				{{ removedStudents() }}
			</nz-tag>
		</div>

		@if (enableEditButton()) {
			<button
				nz-button
				nzType="primary"
				nzSize="small"
				(click)="editSection(section)"
				nzShape="circle"
				nz-tooltip="Edit the section and users"
			>
				<nz-icon nzType="edit" />
			</button>
		}
	}
}
